import { ModuleExtensions } from '@wix/premium-fed-sdk/@premium-module';
export const EntriIntroBiExtension = ModuleExtensions.biEventsExtension();
//# sourceMappingURL=EntriIntroBiExtension.js.map